import trackEvent, { NOT_AVAILABLE } from './trackEvent'

import { TSuggestElement } from '../../types/factFinder'

export type TSearchSentEventProps = {
  searchTerm: string
  suggestion?: TSuggestElement
  selectedSuggestion?: number
  totalSuggestions: number
}
const searchSentEvent = (props: TSearchSentEventProps): void => {
  const { searchTerm, suggestion, selectedSuggestion, totalSuggestions } = props
  trackEvent({
    event: 'searchSent',
    se_searchOrigin: suggestion ? 'suggested' : 'standard',
    se_searchTermSent: suggestion ? suggestion.name : searchTerm,
    se_searchTermTyped: searchTerm,
    se_suggestedTermPosition: typeof selectedSuggestion === 'undefined' ? NOT_AVAILABLE : selectedSuggestion,
    se_totalSuggestedTerms: totalSuggestions,
  })
}

export default searchSentEvent
